import React from "react";
import styled from "styled-components";
import IconStyle from "./IconStyle";

const Svg = styled(IconStyle)`
  width: 24px;
  height: 24px;
`;

export const FacebookIcon = () => (
  <Svg viewBox="0 0 24 24" fill="none">
    <title>Facebook</title>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0H24V24H0z"></path>
      <path
        stroke="currentColor"
        d="M12 22.5c7.991 0 10.5-2.501 10.5-10.466C22.5 4.047 19.97 1.5 12 1.5 4.03 1.5 1.5 4.048 1.5 12.034 1.5 20 4.009 22.5 12 22.5z"
      ></path>
      <path
        fill="currentColor"
        d="M16.282 15.183l.488-3.18h-3.051V9.94c0-.87.426-1.718 1.792-1.718h1.387V5.515S15.64 5.3 14.436 5.3c-2.513 0-4.155 1.523-4.155 4.28v2.423H7.488v3.18h2.793V22h3.438v-6.817h2.563z"
      ></path>
    </g>
  </Svg>
);

export const YoutubeIcon = () => (
  <Svg viewBox="0 0 24 24" fill="none">
    <title>Youtube</title>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0H24V24H0z"></path>
      <path
        stroke="currentColor"
        d="M12 22.5c7.991 0 10.5-2.501 10.5-10.466C22.5 4.047 19.97 1.5 12 1.5 4.03 1.5 1.5 4.048 1.5 12.034 1.5 20 4.009 22.5 12 22.5z"
      ></path>
      <path
        fill="currentColor"
        d="M12.05 7c.484.001 4.396.019 5.42.299.602.164 1.076.648 1.237 1.263.258.98.289 2.898.293 3.344v.188c-.004.446-.035 2.364-.293 3.345-.16.614-.635 1.098-1.237 1.263-.956.26-4.427.293-5.28.297h-.38c-.853-.004-4.324-.036-5.28-.297-.602-.165-1.076-.649-1.237-1.263-.27-1.026-.291-3.075-.293-3.396v-.086c.002-.321.023-2.37.293-3.395.16-.615.635-1.1 1.237-1.263C7.554 7.019 11.466 7 11.95 7zM10 9.5v5l4.5-2.5L10 9.5z"
      ></path>
    </g>
  </Svg>
);

export const InstagramIcon = () => (
  <Svg viewBox="0 0 24 24" fill="none">
    <title>Instagram</title>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0H24V24H0z" />
      <path
        stroke="currentColor"
        d="M12 22.5c7.991 0 10.5-2.501 10.5-10.466C22.5 4.047 19.97 1.5 12 1.5 4.03 1.5 1.5 4.048 1.5 12.034 1.5 20 4.009 22.5 12 22.5z"
      />
      <path
        fill="currentColor"
        d="M12.885 5c1.12.004 1.39.014 2.001.042.745.034 1.254.152 1.7.325.46.18.85.419 1.24.808.389.389.628.78.807 1.24.173.445.291.954.325 1.699.03.645.04.91.042 2.196v1.38c-.002 1.286-.012 1.552-.042 2.196-.034.745-.152 1.254-.325 1.7-.179.46-.418.85-.807 1.24-.39.389-.78.628-1.24.807-.446.173-.955.291-1.7.325-.678.031-.937.04-2.407.042h-.958c-1.47-.001-1.728-.01-2.407-.042-.745-.034-1.254-.152-1.7-.325-.46-.179-.85-.418-1.24-.807-.388-.39-.628-.78-.807-1.24-.173-.446-.291-.955-.325-1.7-.028-.61-.038-.881-.041-2v-1.771c.003-1.12.013-1.39.04-2.001.035-.745.153-1.254.326-1.7.18-.46.419-.85.808-1.24.389-.388.78-.628 1.24-.807.445-.173.954-.291 1.699-.325.61-.028.881-.038 2.001-.041zm-.016 1.262h-1.738c-1.098.003-1.356.012-1.96.04-.682.031-1.053.145-1.3.241-.326.127-.56.279-.804.524-.245.245-.397.478-.524.805-.096.246-.21.617-.241 1.3-.028.603-.037.861-.04 1.959v1.738c.003 1.098.012 1.356.04 1.96.031.682.145 1.053.24 1.3.128.326.28.56.525.805s.478.396.805.523c.246.096.617.21 1.3.241.737.034.959.041 2.828.041h.245c1.646 0 1.88-.009 2.584-.04.682-.032 1.053-.146 1.3-.242.326-.127.56-.278.805-.523s.396-.479.523-.805c.096-.247.21-.618.241-1.3.034-.738.041-.96.041-2.829v-.245c0-1.645-.009-1.879-.04-2.584-.032-.682-.146-1.053-.242-1.3-.127-.326-.278-.56-.523-.804-.245-.245-.479-.397-.805-.524-.247-.096-.618-.21-1.3-.241-.604-.028-.862-.037-1.96-.04zM12 8.405c1.985 0 3.595 1.61 3.595 3.595s-1.61 3.595-3.595 3.595S8.405 13.985 8.405 12 10.015 8.405 12 8.405zm0 1.262c-1.289 0-2.333 1.044-2.333 2.333 0 1.289 1.044 2.334 2.333 2.334 1.289 0 2.334-1.045 2.334-2.334 0-1.289-1.045-2.333-2.334-2.333zm3.737-2.244c.464 0 .84.376.84.84 0 .464-.376.84-.84.84-.464 0-.84-.376-.84-.84 0-.464.376-.84.84-.84z"
      />
    </g>
  </Svg>
);

export const VkontakteIcon = () => (
  <Svg viewBox="0 0 24 24" fill="none">
    <title id="logo-vk">ВКонтакте</title>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0H24V24H0z"></path>
      <path
        stroke="currentColor"
        d="M12 22.5c7.991 0 10.5-2.501 10.5-10.466C22.5 4.047 19.97 1.5 12 1.5 4.03 1.5 1.5 4.048 1.5 12.034 1.5 20 4.009 22.5 12 22.5z"
      ></path>
      <path
        fill="currentColor"
        d="M18.737 8.623c.11-.344 0-.595-.486-.595H16.64c-.407 0-.595.22-.705.454 0 0-.83 2.005-1.989 3.304-.375.376-.548.501-.751.501-.11 0-.25-.125-.25-.47v-3.21c0-.407-.126-.594-.47-.594H9.937c-.25 0-.407.187-.407.375 0 .392.58.486.642 1.582v2.38c0 .517-.094.61-.298.61-.548 0-1.879-2.02-2.677-4.321-.157-.454-.313-.626-.72-.626H4.848c-.47 0-.548.219-.548.454 0 .422.548 2.552 2.552 5.37 1.331 1.926 3.226 2.96 4.933 2.96 1.033 0 1.158-.235 1.158-.626v-1.457c0-.47.094-.548.423-.548.235 0 .658.126 1.613 1.05 1.096 1.095 1.284 1.597 1.895 1.597h1.612c.47 0 .69-.235.564-.69-.14-.454-.673-1.111-1.362-1.894-.376-.439-.94-.924-1.112-1.159-.235-.313-.172-.438 0-.72-.016 0 1.957-2.787 2.161-3.727"
      ></path>
    </g>
  </Svg>
);
